import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { IncentiveProposalsReadApiClient } from '~/services/Http';

import {
  IncentiveDto,
  Order4,
  WorkflowStatuses2,
} from '../../client.rewarding.generated';

export const GET_INCENTIVE_PROPOSALS_SWR_KEY =
  'IncentiveProposalsReadApiClient.getAllProposals';

export function useGetIncentiveProposals(
  args?: {
    order?: Order4;
    offset?: number;
    limit?: number;
    startDate?: Date;
    endDate?: Date;
    lang?: string;
    includeHistory?: boolean;
    uids?: string[];
    employeeIds?: number[];
    unitIds?: number[];
    roles?: string[];
    workflowStatuses?: WorkflowStatuses2[];
    workflowHandlers?: number[];
    sort?: string[];
  },
  swrConfig?: SWRConfiguration<IncentiveDto[]>,
  disable?: boolean,
): UseSWROutput<IncentiveDto[]> {
  return useSWR(
    !disable
      ? [
          GET_INCENTIVE_PROPOSALS_SWR_KEY,
          args?.order ?? undefined,
          args?.offset ?? undefined,
          args?.limit ?? undefined,
          args?.startDate ?? undefined,
          args?.endDate ?? undefined,
          args?.lang ?? undefined,
          args?.includeHistory ?? undefined,
          args?.uids ?? undefined,
          args?.employeeIds ?? undefined,
          args?.unitIds ?? undefined,
          args?.roles ?? undefined,
          args?.workflowStatuses ?? undefined,
          args?.workflowHandlers ?? undefined,
          args?.sort ?? undefined,
        ]
      : null,
    ([
      _,
      order,
      offset,
      limit,
      startDate,
      endDate,
      lang,
      includeHistory,
      uids,
      employeeIds,
      unitIds,
      roles,
      workflowStatuses,
      workflowHandlers,
      sort,
    ]) =>
      IncentiveProposalsReadApiClient.getAllProposals(
        order,
        offset,
        limit,
        startDate,
        endDate,
        lang,
        includeHistory,
        uids,
        employeeIds,
        unitIds,
        roles,
        workflowStatuses,
        workflowHandlers,
        sort,
      ).then((r) => r.data),
    swrConfig,
  );
}
